import { defineStore } from 'pinia';
import { shallowRef, watch } from 'vue';
import { authState } from '@lcp/http-auth';
import type { IBenchmarkPoolApprovalContext, IResolvedBenchmarkPool, ILeaderboardBenchmarkPoolReference } from '@/interfaces/powerMarkets/leaderboard/IBenchmarkPool.ts';

export interface IBenchmarkPoolResolution {
    reference: ILeaderboardBenchmarkPoolReference;
    requiresUndersizedApproval: boolean;
    preview: IResolvedBenchmarkPool;
    approvalContext: IBenchmarkPoolApprovalContext;
}

function createSession (): { id: string; resolutions: Map<string, Promise<IBenchmarkPoolResolution>> } {
    return { id: crypto.randomUUID(), resolutions: new Map() };
}

export const useBenchmarkPoolSessionStore = defineStore('benchmarkPoolSession', () => {
    // Keep promises and approval state out of serializable user/module settings.
    let session = createSession();
    const definitionVersions = shallowRef<Record<string, number>>({});
    watch(
        () => (authState.value.loggedIn ? authState.value.userInfo?.username : undefined),
        () => { session = createSession(); definitionVersions.value = {}; },
        { flush: 'sync' },
    );

    function getSession (): ReturnType<typeof createSession> {
        return session;
    }

    function notifyDefinitionChanged (poolId: string): void {
        definitionVersions.value = { ...definitionVersions.value, [poolId]: (definitionVersions.value[poolId] ?? 0) + 1 };
    }

    return { getSession, definitionVersions, notifyDefinitionChanged };
});
